import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none"><path fill="currentColor" d="M6.52 3.522 9.634 3a3.852 3.852 0 0 0-.532 1.656l-1.134 13.27c-.079.92.17 1.793.646 2.497a1.882 1.882 0 0 1-1.527-1.57L4.985 5.709c-.166-1.037.521-2.016 1.534-2.186Zm10.327-.082-3.878-.348c-1.023-.091-1.925.683-2.014 1.73l-1.134 13.27a1.935 1.935 0 0 0 .188 1.016c.28.572.834.986 1.502 1.046l8.334.746c1.023.092 1.924-.683 2.014-1.73L22.993 5.9c.09-1.047-.667-1.97-1.69-2.061l-4.456-.4ZM1.154 5.83l1.967-.826a3.9 3.9 0 0 0 .03 1.011l2.103 13.146c.112.704.407 1.331.826 1.839a1.869 1.869 0 0 1-1.312-1.135L.14 8.313C-.25 7.34.204 6.229 1.154 5.83Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
